import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getAvailableVehicles = async (user_id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/vehicle-list/?user_id=${user_id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const getVehicles = async (user_id) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/vehicle-data/?user_id=${user_id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const createVehicle = async (data) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/vehicle-data/?user_id=${data?.user_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const deleteVehicle = async (vehicle_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/vehicle-data/?vehicle_id=${vehicle_id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const deleteAllVehicles = async (user_id) => {
  try {
    const res = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/vehicle-data/?user_id=${user_id}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const updateVehicle = async (vehicle_id, data) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/vehicle-data/?vehicle_id=${vehicle_id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

const createBulkVehicles = async (data,user_id) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}admin-panel/vehicle-data/?user_id=${user_id}`,
      Array.isArray(data) ? data : [data],
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};


export { getAvailableVehicles, createVehicle, getVehicles, deleteVehicle, deleteAllVehicles, updateVehicle, createBulkVehicles};
